export { default as Results } from './Results';
export { default as GroupSingle } from './GroupSingle';



// WEBPACK FOOTER //
// ./src/group-finder/index.js